module.exports = __webpack_public_path__ + "85df6e643011374296a8ac2110162f82.svg";